/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    TRACING_SYSTEM
 * Date:         2025-12-20
 * Modified By:  Cursor
 *
 * Description:
 * Admin service for trace monitoring.
 */

import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';
import { config } from '../config/environment';

const API_URL = config.apiUrl;

export interface AdminTracesParams {
  status?: string;
  type?: string;
  subtype?: string;
  userName?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
  device?: string;
  country?: string;
  ip?: string;
  limit?: number;
  page?: number;
}

export interface TraceStats {
  total: number;
  byStatus: {
    PENDING?: number;
    PROCESSING?: number;
    SUCCESS?: number;
    FAILED?: number;
  };
  byType: {
    MAIL?: number;
    UPLOAD?: number;
    BROADCAST?: number;
    INVENTORY_BULK?: number;
  };
  avgDuration: {
    avgMs: number;
  };
}

/**
 * Get all traces (admin)
 */
export async function getAllTraces(params: AdminTracesParams = {}) {
  const response = await axios.get(`${API_URL}/api/admin/traces`, {
    params,
    headers: getAuthHeaders().headers
  });
  return response.data;
}

/**
 * Get trace statistics (admin)
 */
export async function getTraceStats() {
  const response = await axios.get(`${API_URL}/api/admin/traces/stats`, {
    headers: getAuthHeaders().headers
  });
  return response.data;
}

/**
 * Get specific trace by traceId with related data (admin)
 */
export async function getAdminTraceById(traceId: string) {
  const response = await axios.get(`${API_URL}/api/admin/traces/${traceId}`, {
    headers: getAuthHeaders().headers
  });
  return response.data;
}

/**
 * Retry failed traces (bulk action)
 */
export async function retryFailedTraces(traceIds: string[]) {
  const response = await axios.post(
    `${API_URL}/api/admin/traces/retry`,
    { traceIds },
    { headers: getAuthHeaders().headers }
  );
  return response.data;
}

